module.exports = function() {
  return new Worker(__webpack_public_path__ + "be17143f951f244b4166.worker.js");
};